export const SET_NETWORK_STATUS = 'SET_NETWORK_STATUS';

export const setNetworkStatus = (isOnline) => ({
  type: SET_NETWORK_STATUS,
  isOnline,
});
